module.exports = __webpack_public_path__ + "static/media/Settings.543c1d12.png";